export default __webpack_public_path__ + "static/media/Voldemort's Wand - Img - Wip 1_00.61539da7.jpg";